import moment from "moment";
import httpCommon from "../../http-common";

const getForStudent = async (id, studentId) => {
  console.log('In classservice.get for id', id);
  const classes = await httpCommon.http.get(`/classes/${id}?studentId=${studentId}`);
  console.log(classes);
  const clazz = classes?.data?.data;
  clazz.dates = clazz.classDates.forEach(d => {
    d.classDate = new Date(Date.parse(d.classDate))
  });
  return clazz;
};

const getAllSpecialEvents = async () => {
  const events = await httpCommon.http.get(`/events`);
  console.log(events);
  const event = events?.data?.data;
  event.eventDates?.forEach(d => {
    d.eventDate = new Date(Date.parse(d.eventDate))
  });
  return event;
};

const ClassService = {
  getForStudent,
  getAllSpecialEvents
};

export default ClassService;